import styled from "styled-components";
import { Link } from "react-router-dom";

export const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  word-break: break-word;
`;

export const Label = styled.span`
  font-size: 12px;
  line-height: 16px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.palette[650]};
  letter-spacing: 0.4px;
`;

export const Value = styled.span`
  color: ${({ theme }) => theme.palette[850]};
  white-space: pre-wrap;
`;

export const LinkValue = styled(Link)`
  color: ${({ theme }) => theme.primary[600]};
  white-space: pre-wrap;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

export const SecondaryValue = styled.span`
  color: ${({ theme }) => theme.palette[650]};
  white-space: pre-wrap;
`;

export const EmptyValue = styled.span`
  color: ${({ theme }) => theme.palette[650]};
`;

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  word-break: break-word;
`;

export const UserName = styled.span`
  color: ${({ theme }) => theme.palette[850]};
  font-weight: 500;
`;

export const UserLink = styled(Link)`
  color: ${({ theme }) => theme.primary[600]};
  font-weight: 500;
  text-decoration: none;
  word-break: break-word;
  &:hover {
    text-decoration: underline;
  }
`;

export const UserMeta = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  color: ${({ theme }) => theme.palette[650]};
  font-size: 13px;
  line-height: 18px;

  & > span {
    color: ${({ theme }) => theme.palette[650]};
  }
`;

export const Recipients = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  word-break: break-word;
`;
